import type { ICelloState } from './types';

import * as ActionTypes from 'src/state/action-types';

export const initialState: ICelloState = {
  productId: null,
  token: null,
  language: null,
  firstName: null,
  lastName: null,
  email: null,
  fullName: null,

  ucc: null,
};

export default function celloReducer(
  state: ICelloState = initialState,
  action: ActionTypes.ActionTypes
): ICelloState {
  switch (action.type) {
    case ActionTypes.CELLO_INIT:
    case ActionTypes.CELLO_INIT_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
